/* =========================================================
   NITIDUS v2 — product-first interactions
   Hair field · hero parallax · product bar · closer-look explorer
   · scroll-lit statement · fly-to-cart. No dependencies.
   ========================================================= */
(function () {
  'use strict';
  var N = window.Nitidus = window.Nitidus || {};
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia('(pointer: fine)').matches;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };

  /* ---------- One shared scroll loop ---------- */
  var scrollers = [], ticking = false;
  function onScroll(fn) { scrollers.push(fn); fn(); }
  function runScroll() { ticking = false; for (var i = 0; i < scrollers.length; i++) scrollers[i](); }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(runScroll); } }, { passive: true });
  window.addEventListener('resize', function () { if (!ticking) { ticking = true; requestAnimationFrame(runScroll); } });

  /* =========================================================
     1. Hair field: loose strands drift toward the mitt and vanish
        into its pad. Batched strokes, paused off-screen.
     ========================================================= */
  function HairField(host, target) {
    var c = document.createElement('canvas'), x = c.getContext('2d');
    host.appendChild(c);
    var W, H, dpr, strands = [], t0 = performance.now(), last = t0, visible = true, pointer = null, T = { x: 0, y: 0, r: 60 }, pull = 0;
    var COLS = ['#D6AE72', '#C8985A', '#E7CE9F', '#B88549', '#9AA0A7', '#EFE6D6'];
    function size() {
      var r = host.getBoundingClientRect(); dpr = Math.min(window.devicePixelRatio || 1, 2);
      W = Math.max(200, r.width); H = Math.max(200, r.height);
      c.width = W * dpr; c.height = H * dpr; c.style.width = W + 'px'; c.style.height = H + 'px';
      var n = Math.round(clamp(W * H / 8500, 36, 120)); while (strands.length < n) strands.push(spawn(true)); strands.length = n;
      aim();
    }
    function aim() {
      if (!target) { T.x = W / 2; T.y = H / 2; T.r = 80; return; }
      var hr = host.getBoundingClientRect(), tr = target.getBoundingClientRect();
      T.x = tr.left - hr.left + tr.width * .5; T.y = tr.top - hr.top + tr.height * .55; T.r = Math.min(tr.width, tr.height) * .34;
    }
    function spawn(anywhere) {
      var s = { len: 7 + Math.random() * 14, curl: (Math.random() - .5) * .8, col: (Math.random() * COLS.length) | 0, a: Math.random() * 6.283, va: (Math.random() - .5) * .6, life: 1, w: .8 + Math.random() * .9 };
      if (anywhere) { s.x = Math.random() * W; s.y = Math.random() * H; }
      else { var e = (Math.random() * 4) | 0; s.x = e === 0 ? -20 : e === 1 ? W + 20 : Math.random() * W; s.y = e === 2 ? -20 : e === 3 ? H + 20 : Math.random() * H; }
      s.vx = (Math.random() - .5) * 10; s.vy = (Math.random() - .5) * 10; return s;
    }
    function step(dt, now) {
      var tt = (now - t0) / 1000, reach = Math.max(W, H) * (.34 + pull * .5);
      for (var i = 0; i < strands.length; i++) {
        var s = strands[i];
        // gentle flow field
        var fx = Math.sin(s.y * .012 + tt * .35) * 6, fy = Math.cos(s.x * .011 - tt * .3) * 5;
        var dx = T.x - s.x, dy = T.y - s.y, d = Math.sqrt(dx * dx + dy * dy) || 1;
        var k = d < reach ? (1 - d / reach) : 0; k = k * k * (90 + pull * 260);
        s.vx += ((fx + dx / d * k) - s.vx * .9) * dt * 1.6;
        s.vy += ((fy + dy / d * k) - s.vy * .9) * dt * 1.6;
        if (pointer) { var px = s.x - pointer.x, py = s.y - pointer.y, pd = px * px + py * py; if (pd < 9000) { var f = (1 - pd / 9000) * 140; pd = Math.sqrt(pd) || 1; s.vx += px / pd * f * dt; s.vy += py / pd * f * dt; } }
        s.x += s.vx * dt; s.y += s.vy * dt;
        var sp = Math.sqrt(s.vx * s.vx + s.vy * s.vy);
        var want = Math.atan2(s.vy, s.vx); s.a += sp > 18 ? (Math.atan2(Math.sin(want - s.a), Math.cos(want - s.a))) * dt * 3 : s.va * dt;
        if (d < T.r) s.life -= dt * 3.2;
        if (s.life <= 0 || s.x < -60 || s.x > W + 60 || s.y < -60 || s.y > H + 60) strands[i] = spawn(false);
      }
    }
    var paths = COLS.map(function () { return null; });
    function draw() {
      x.setTransform(dpr, 0, 0, dpr, 0, 0); x.clearRect(0, 0, W, H); x.lineCap = 'round';
      for (var p = 0; p < COLS.length; p++) paths[p] = [new Path2D(), new Path2D()];
      for (var i = 0; i < strands.length; i++) {
        var s = strands[i], L = s.len * Math.max(.2, s.life), ca = Math.cos(s.a) * L, sa = Math.sin(s.a) * L;
        var g = paths[s.col][s.life < .6 ? 1 : 0];
        g.moveTo(s.x - ca / 2, s.y - sa / 2); g.quadraticCurveTo(s.x - sa * s.curl, s.y + ca * s.curl, s.x + ca / 2, s.y + sa / 2);
      }
      for (var q = 0; q < COLS.length; q++) {
        x.strokeStyle = COLS[q];
        x.globalAlpha = .85; x.lineWidth = 1.3; x.stroke(paths[q][0]);
        x.globalAlpha = .35; x.stroke(paths[q][1]);
      }
      x.globalAlpha = 1;
    }
    function loop(now) {
      if (!visible || document.hidden) { running = false; return; }
      var dt = Math.min(.05, (now - last) / 1000); last = now;
      step(dt, now); draw(); requestAnimationFrame(loop);
    }
    var running = false;
    function start() { if (running || RM) return; running = true; last = performance.now(); requestAnimationFrame(loop); }
    size();
    if (RM) { draw(); } else start();
    new ResizeObserver(function () { size(); if (RM) draw(); }).observe(host);
    new IntersectionObserver(function (e) { visible = e[0].isIntersecting; if (visible) { aim(); start(); } }).observe(host);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) start(); });
    if (FINE) {
      host.addEventListener('pointermove', function (e) { var r = host.getBoundingClientRect(); pointer = { x: e.clientX - r.left, y: e.clientY - r.top }; });
      host.addEventListener('pointerleave', function () { pointer = null; });
    }
    return { aim: aim, setPull: function (v) { pull = v; } };
  }

  /* =========================================================
     2. Hero: tilt toward the cursor, mitts part as you scroll
     ========================================================= */
  var hp = $('[data-hp]');
  if (hp) {
    var stage = $('[data-hp-stage]', hp), prod = $('[data-hp-product]', hp), target = $('[data-hp-target]', hp) || stage;
    var field = $('[data-hair-field]', hp) ? HairField($('[data-hair-field]', hp), target) : null;
    if (prod && !RM) {
      onScroll(function () {
        var r = hp.getBoundingClientRect(), p = clamp(-r.top / Math.max(1, r.height * .8), 0, 1);
        prod.style.setProperty('--sp', p.toFixed(3));
        if (field) { field.setPull(p); field.aim(); }
      });
      if (FINE) {
        hp.addEventListener('pointermove', function (e) {
          var r = hp.getBoundingClientRect();
          prod.style.setProperty('--tx', (((e.clientX - r.left) / r.width - .5) * 16).toFixed(2) + 'deg');
          prod.style.setProperty('--ty', (-((e.clientY - r.top) / r.height - .5) * 12).toFixed(2) + 'deg');
        });
        hp.addEventListener('pointerleave', function () { prod.style.setProperty('--tx', '0deg'); prod.style.setProperty('--ty', '0deg'); });
      }
    }
    var imgs = $$('img', hp); var ready = function () { hp.classList.add('is-ready'); if (field) field.aim(); };
    if (imgs.every(function (i) { return i.complete; })) ready(); else imgs.forEach(function (i) { i.addEventListener('load', ready, { once: true }); });
    setTimeout(ready, 1200);
  }

  /* =========================================================
     3. Product bar: dropdown on mobile, scroll-spy, stuck state
     ========================================================= */
  var sub = $('[data-subnav]');
  if (sub) {
    document.documentElement.classList.add('has-subnav');
    var tog = $('[data-subnav-toggle]', sub), links = $$('[data-spy]', sub);
    var close = function () { sub.classList.remove('is-open'); tog.setAttribute('aria-expanded', 'false'); };
    tog.addEventListener('click', function () { var o = !sub.classList.contains('is-open'); sub.classList.toggle('is-open', o); tog.setAttribute('aria-expanded', String(o)); });
    links.forEach(function (a) { a.addEventListener('click', close); });
    document.addEventListener('click', function (e) { if (!sub.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    var wrap = sub.parentElement, targets = links.map(function (a) { var id = (a.getAttribute('href') || '').replace('#', ''); return document.getElementById(id); });
    onScroll(function () {
      var top = wrap.getBoundingClientRect().top;
      sub.classList.toggle('is-stuck', top <= 0.5);
      var mark = window.innerHeight * .35, cur = -1;
      targets.forEach(function (t, i) { if (t && t.getBoundingClientRect().top - mark <= 0) cur = i; });
      links.forEach(function (a, i) { a.classList.toggle('is-current', i === cur); if (i === cur) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
    });
  }
  $$('[data-scroll-swipe]').forEach(function (bar) {
    onScroll(function () { var max = document.documentElement.scrollHeight - window.innerHeight; bar.style.setProperty('--p', max > 0 ? clamp(window.scrollY / max, 0, 1).toFixed(4) : 0); });
  });

  /* =========================================================
     4. Take a closer look: the step in view drives the stage
     ========================================================= */
  $$('[data-explorer]').forEach(function (ex) {
    var stageEl = $('[data-ex-stage]', ex), zoom = $('[data-ex-zoom]', ex), steps = $$('[data-ex-step]', ex), title = $('[data-ex-title]', ex), dots = $$('.ex__dots li', ex);
    var active = 0;
    var callout = $('[data-ex-callout]', ex), cards = $$('.ex__card', ex);
    function apply(i) {
      var st = steps[i]; if (!st) return; active = i;
      var mode = st.dataset.mode, x = +st.dataset.x, y = +st.dataset.y;
      // No enlargement: the photo stays at native size. The feature is lit, the rest fades back,
      // and the mitt turns a few degrees toward the viewer.
      if (mode === 'zoom') {
        zoom.style.transform = 'rotateY(' + ((x - 50) * -.22).toFixed(2) + 'deg) rotateX(' + ((y - 50) * .16).toFixed(2) + 'deg)';
        stageEl.style.setProperty('--fx', x + '%'); stageEl.style.setProperty('--fy', y + '%');
        if (callout) { callout.textContent = $('.ex__title', st).textContent; callout.classList.toggle('is-below', y < 30); }
      } else if (mode === 'lens') {
        zoom.style.transform = 'translate(-18%, -6%) scale(.72) rotate(-6deg)';
      } else {
        zoom.style.transform = 'scale(.8)';
      }
      stageEl.dataset.step = String(i + 1); stageEl.dataset.mode = mode === 'zoom' ? 'spot' : mode;
      steps.forEach(function (el, k) { el.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      $$('.ex__hs', ex).forEach(function (h) { h.classList.toggle('is-active', +h.dataset.exGoto === i + 1); });
      if (title) title.textContent = $('.ex__title', st).textContent;
    }
    onScroll(function () {
      var mark = window.innerHeight * (window.innerWidth < 990 ? .72 : .55), best = 0;
      steps.forEach(function (st, i) { if (st.getBoundingClientRect().top < mark) best = i; });
      if (best !== active || !stageEl.dataset.init) { stageEl.dataset.init = '1'; apply(best); }
      // Stacked layout: cards fade as they slide up under the pinned product, so no text shows above it
      if (window.innerWidth < 990) {
        var sb = stageEl.getBoundingClientRect().bottom;
        cards.forEach(function (c) { var t = c.getBoundingClientRect().top; c.style.opacity = clamp((t - sb + 140) / 160, 0, 1).toFixed(3); });
      } else if (cards[0] && cards[0].style.opacity) cards.forEach(function (c) { c.style.opacity = ''; });
    });
    window.addEventListener('resize', function () { apply(active); });
    $$('[data-ex-goto]', ex).forEach(function (b) {
      b.addEventListener('click', function () { var st = steps[+b.dataset.exGoto - 1]; if (st) st.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'center' }); });
    });
  });

  /* =========================================================
     5. Statement: words light up as you scroll through
     ========================================================= */
  $$('[data-statement]').forEach(function (el) {
    var raw = el.textContent.trim(), words = raw.split(/\s+/), key = false;
    el.textContent = '';
    var spans = words.map(function (w) {
      var start = w.charAt(0) === '[', end = /\][.,!?;:]*$/.test(w);
      if (start) key = true;
      var sp = document.createElement('span'); sp.className = 'sw' + (key ? ' sw--key' : '');
      sp.textContent = w.replace('[', '').replace(']', '');
      if (end) key = false;
      el.appendChild(sp); el.appendChild(document.createTextNode(' ')); return sp;
    });
    el.classList.add('is-split');
    if (RM) { spans.forEach(function (s) { s.classList.add('is-lit'); }); return; }
    onScroll(function () {
      var r = el.getBoundingClientRect(), vh = window.innerHeight;
      var p = clamp((vh * .82 - r.top) / (r.height + vh * .3), 0, 1), n = Math.round(p * spans.length);
      for (var i = 0; i < spans.length; i++) spans[i].classList.toggle('is-lit', i < n);
    });
  });

  /* =========================================================
     8. Limited-time offer countdown (to a real end date from theme settings)
     ========================================================= */
  var cds = $$('[data-countdown]');
  var parseWhen = function (raw, tz) {
    raw = (raw || '').trim().replace(' ', 'T'); if (!raw) return NaN;
    if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) raw += 'T23:59';
    return Date.parse(raw + ':00' + (tz || '+00:00'));
  };
  if (cds.length) {
    var src = cds[0], tz = src.dataset.tz;
    var start = parseWhen(src.dataset.start, tz), end = parseWhen(src.dataset.countdown, tz);
    // Flash sale: a real window that starts at a set time and lasts a set number of hours
    if (src.dataset.mode === 'flash') end = start + (+src.dataset.hours || 24) * 3600e3;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var dock = $('[data-dock]');
    var expire = function () {
      cds.forEach(function (c) { c.remove(); });
      if (dock) dock.remove();
      $$('[data-sale-bar]').forEach(function (b) { b.remove(); });
      $$('[data-sale-fallback]').forEach(function (b) { b.hidden = false; });
    };
    if (!end || isNaN(end) || end <= Date.now() || (src.dataset.mode === 'flash' && !(start <= Date.now()))) expire();
    else {
      var last = {}, hasMeter = start && !isNaN(start) && start < end;
      var tick = function () {
        var now = Date.now(), left = Math.max(0, Math.floor((end - now) / 1000));
        if (!left) { expire(); return; }
        var v = { d: Math.floor(left / 86400), h: Math.floor(left % 86400 / 3600), m: Math.floor(left % 3600 / 60), s: left % 60 };
        ['d', 'h', 'm', 's'].forEach(function (k) {
          if (last[k] === v[k]) return; last[k] = v[k];
          $$('[data-cd="' + k + '"]').forEach(function (el) {
            el.textContent = pad(v[k]);
            if (!RM) { el.classList.remove('is-tick'); void el.offsetWidth; el.classList.add('is-tick'); }
          });
        });
        // Under a day left: drop the days unit so it reads as hours and minutes
        $$('[data-cd-unit="d"]').forEach(function (el) { el.hidden = v.d === 0; });
        var short = (v.d ? v.d + 'd ' : '') + pad(v.h) + ':' + pad(v.m) + ':' + pad(v.s);
        $$('[data-cd-short]').forEach(function (el) { el.textContent = short; });
        var urgent = left < 86400, critical = left < 3 * 3600;
        cds.concat(dock ? [dock] : []).forEach(function (c) { c.classList.toggle('is-final', urgent); c.classList.toggle('is-critical', critical); });
        if (hasMeter) {
          var p = Math.max(0, Math.min(1, (end - now) / (end - start)));
          $$('[data-cd-meter]').forEach(function (m) { m.style.transform = 'scaleX(' + p.toFixed(4) + ')'; });
          $$('[data-cd-meter-label]').forEach(function (m) { m.textContent = Math.round((1 - p) * 100) + '% of the offer time has gone'; });
        }
        // A little shake on each new minute, so the timer catches the eye mid-scroll
        if (v.s === 0 && !RM) cds.concat(dock ? [$('.dock__inner', dock)] : []).forEach(function (c) { c.classList.remove('is-nudge'); void c.offsetWidth; c.classList.add('is-nudge'); });
      };
      tick(); setInterval(tick, 1000);

      /* Dock: shows once the hero is gone; steps aside at the pack chooser, footer, and when sheets are open */
      if (dock) {
        var heroEl = $('[data-hero]') || $('.pdp__info'), buyEl = document.getElementById('buy'), footEl = $('.site-footer');
        var st = { hero: true, buy: false, foot: false };
        var btn = $('.dock__btn', dock);
        var upd = function () {
          var show = !st.hero && !st.buy && !st.foot && !document.body.classList.contains('drawer-open');
          dock.classList.toggle('is-visible', show); dock.setAttribute('aria-hidden', String(!show)); btn.tabIndex = show ? 0 : -1;
          document.documentElement.classList.toggle('dock-on', show);
        };
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (es) {
            es.forEach(function (e) { if (e.target === heroEl) st.hero = e.isIntersecting; if (e.target === buyEl) st.buy = e.isIntersecting; if (e.target === footEl) st.foot = e.isIntersecting; });
            upd();
          }, { threshold: 0.05 });
          [heroEl, buyEl, footEl].forEach(function (el) { if (el) io.observe(el); });
          if (!heroEl) st.hero = false;
        }
        new MutationObserver(upd).observe(document.body, { attributes: true, attributeFilter: ['class'] });
      }
    }
  }

  /* =========================================================
     7. Quick-buy sheet: every "Buy" opens the pack chooser in place
     ========================================================= */
  var qb = $('[data-qb]');
  if (qb) {
    var panel = $('.qb__panel', qb), lastFocus = null;
    var openQB = function (e) {
      if (e) e.preventDefault();
      lastFocus = document.activeElement; qb.hidden = false;
      requestAnimationFrame(function () { qb.classList.add('is-open'); panel.focus(); });
      document.body.classList.add('drawer-open');
      if (sub) sub.classList.remove('is-open');
    };
    var closeQB = function () {
      if (qb.hidden) return;
      qb.classList.remove('is-open'); document.body.classList.remove('drawer-open');
      setTimeout(function () { qb.hidden = true; }, 380);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    };
    $$('[data-quick-buy]').forEach(function (b) { b.addEventListener('click', openQB); });
    $$('[data-qb-close]', qb).forEach(function (b) { b.addEventListener('click', closeQB); });
    qb.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeQB();
      if (e.key === 'Tab') { var f = $$('button:not([disabled]), input:not([disabled]), a[href]', panel).filter(function (x) { return x.offsetParent; }); if (!f.length) return; if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); } else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); } }
    });
    document.addEventListener('nit:added', function () { setTimeout(closeQB, 60); });
    // swipe down to dismiss on phones
    var sy = null; panel.addEventListener('touchstart', function (e) { sy = panel.scrollTop <= 0 ? e.touches[0].clientY : null; }, { passive: true });
    panel.addEventListener('touchmove', function (e) { if (sy == null) return; var d = e.touches[0].clientY - sy; if (d > 0) panel.style.transform = 'translateY(' + d + 'px)'; }, { passive: true });
    panel.addEventListener('touchend', function (e) { if (sy == null) return; var d = e.changedTouches[0].clientY - sy; panel.style.transform = ''; sy = null; if (d > 90) closeQB(); });
  }

  /* =========================================================
     6. Fly-to-cart: a mitt arcs from the button into the cart
     ========================================================= */
  N.flyToCart = function (fromEl, done) {
    var to = $$('[data-cart-toggle]').filter(function (a) { var r = a.getBoundingClientRect(); return r.width && r.bottom > 0 && r.top < window.innerHeight; })[0];
    if (RM || !fromEl || !to || !N.fallbackImg || !document.body.animate) { done && done(); return; }
    var a = fromEl.getBoundingClientRect(), b = to.getBoundingClientRect();
    var img = document.createElement('img'); img.src = N.fallbackImg; img.alt = ''; img.className = 'fly-mitt';
    var sx = a.left + a.width / 2 - 28, sy = a.top + a.height / 2 - 36, ex = b.left + b.width / 2 - 28, ey = b.top + b.height / 2 - 36;
    img.style.left = sx + 'px'; img.style.top = sy + 'px'; document.body.appendChild(img);
    var mx = (ex - sx) * .55, my = Math.max(24 - sy, Math.min(ey - sy, 0) - 110);
    var anim = img.animate([
      { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1 },
      { transform: 'translate(' + mx + 'px,' + my + 'px) scale(.8) rotate(-14deg)', opacity: 1, offset: .55 },
      { transform: 'translate(' + (ex - sx) + 'px,' + (ey - sy) + 'px) scale(.18) rotate(8deg)', opacity: .6 }
    ], { duration: 720, easing: 'cubic-bezier(.5,0,.3,1)' });
    anim.onfinish = function () {
      img.remove(); to.classList.remove('is-bump'); void to.offsetWidth; to.classList.add('is-bump');
      done && done();
    };
  };
})();
